import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../api/apiService";
import { Gheader } from "./Gheader";
import InventoryModel from "./InventoryModel";
import InventoryTable from "./InventoryTable";
import styles from "./Rate.module.css";
import { Sidebar } from "./Sidebar";

export const Inventory = () => {
  const hotelId = localStorage.getItem("hotel");
  const [loading, setLoading] = useState("false");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const addInventory = (newInventory) => {
    setInventoryData([newInventory, ...inventoryData]);
  };

  /* Fetching Rates from endpoint and updating local state */
  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(`/inventory/?hotel=${hotelId}`);
      setInventoryData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Inventory</h3>
          <div className={`${styles.buttonContainer} ps-2 ps-md-0`}>
            <button
              className={styles.addRateButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add inventory
            </button>
            {/* <FilterButton /> */}
          </div>

          <InventoryTable
            data={inventoryData}
            setData={setInventoryData}
            hotelId={hotelId}
            fetchInventory={fetchInventory}
            loading={loading}
            setLoading={setLoading}
          />

          {isModelOpen && (
            <InventoryModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addInventory}
              hotelId={hotelId}
            />
          )}
        </div>
      </div>
      <ToastContainer autoClose={1500} position="top-right" />
    </div>
  );
};

export default Inventory;
